import { RefObject, useRef, useCallback } from "react";
import { useIntl } from "react-intl";

import { useToast } from "../context/toast";

interface Opts<T> {
  ref?: RefObject<T>;
  disableToast?: boolean;
  toastMessage?: string;
}

interface Return<T> {
  ref: RefObject<T>;
  copy: (text?: string) => void;
}

export default <T extends HTMLTextAreaElement | HTMLInputElement = HTMLTextAreaElement>({
  ref: refOpt,
  disableToast,
  toastMessage,
}: Opts<T> = {}): Return<T> => {
  const intl = useIntl();
  const showToast = useToast();
  const refVar = useRef<T>(null);
  const ref = refOpt || refVar;

  const copy = useCallback(
    async (text) => {
      try {
        // @ts-expect-error
        // eslint-disable-next-line compat/compat
        await navigator.clipboard.writeText(text || ref.current.value);
        if (!disableToast)
          showToast(toastMessage || intl.formatMessage({ id: "toast.copied" }), {
            variant: "short",
          });
      } catch (error) {
        console.error("> useCopy: ", error);
      }
    },
    [ref, disableToast, showToast, intl, toastMessage]
  );

  return { ref, copy };
};
